module.exports = __webpack_public_path__ + "img/form-lower-title-mobile.c18f1b7b.png";